import { Typography } from '@material-ui/core';
import logoGoogle from 'assets/images/logo-google.svg';
import React from 'react';
import GoogleLogin from 'react-google-login';
import useStyles from './GoogleButtonStyles';
var GoogleButton = function (_a) {
    var className = _a.className, text = _a.text, clientId = _a.clientId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var styles = useStyles();
    return (React.createElement(GoogleLogin, { clientId: clientId, cookiePolicy: "single_host_origin", autoLoad: !true, prompt: "login", render: function (renderProps) { return (React.createElement("button", { className: styles.google + " " + className, type: "button", onClick: renderProps.onClick, disabled: renderProps.disabled },
            React.createElement("img", { src: logoGoogle, alt: "", className: "" + styles.icono__google }),
            React.createElement(Typography, { className: styles.google_descripcion }, text))); }, onSuccess: onSuccess, onFailure: onFailure }));
};
GoogleButton.defaultProps = {
    className: '',
};
export default GoogleButton;
